export default __webpack_public_path__ + "static/media/icon-social-newsfeed.2a9651bf.svg";